import React, {useContext, useEffect, useState} from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import P from "../lib/P";
import {StoreContext} from "../components/StoreContextProvider";
import ModeSelect from "../components/ModeSelect";
import Btn from "../components/Btn";

type Props = { visible?: boolean, onRequestClose: () => void, isFreePlay: boolean, playModeChange: () => void };

const PlayModeModal = (props: Props) => {
  const {visible, isFreePlay} = props;
  const Context = useContext(StoreContext);
  const {user} = Context;
  const [value, setValue] = useState<boolean>();

  const onConfirm = () => {
    if (!isFreePlay && user?.autoPlayEnabled !== value) {
      props.playModeChange();
    }

    props.onRequestClose();
  };

  useEffect(() => {
    if (!isFreePlay && visible) setValue(user?.autoPlayEnabled);
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onRequestClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Play Mode</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={props.onRequestClose}
                />
              </Div>

              <Div px={20} pb={20}>
                <P fontFamily="DavisSans-Regular" ta="center" my={30}>Keep playing to unlock other modes.</P>

                <Div gap={20} mb={103}>
                  {isFreePlay && (
                    <ModeSelect title="FREE PLAY" subtitle="Get started with 10 free shots on us!" selected/>
                  )}

                  {/* SMG-4387 (review round 7): these two options control
                      AUTO-ACCEPT CONSENT (auto_play_consent), and nothing
                      else. The copy used to call the OFF option "SINGLE
                      SHOT", with a subtitle promising per-shot confirm —
                      which this control does not deliver. That name and that
                      behaviour belong to ShotAmountModal's "Single Shot mode"
                      switch, which owns the on_shot / confirmationBypass axis.

                      The collision was invisible until now: commit 6dd522ad2
                      (2026-04-20) deleted both of this modal's openers, so it
                      had no call site for five months. Restoring the opener
                      un-orphaned it and put two live controls sharing a name
                      and disagreeing on screen — a confirm-on-shot player with
                      autoplay on would read "AUTO PLAY" here and "Single Shot
                      mode: ON" there, simultaneously. On a consent control the
                      label is part of the contract, so the option is renamed
                      to the axis it actually moves. Copy only; no behaviour
                      moved with it. */}
                  <ModeSelect
                    title="AUTO PLAY"
                    subtitle="Each new challenge is accepted and your wager placed automatically. Swing away in the sim — all you need to change is the Shot Amount."
                    disabled={isFreePlay} onPress={() => setValue(true)} selected={value}
                  />

                  <ModeSelect
                    title="MANUAL" onPress={() => setValue(false)} disabled={isFreePlay} selected={value === false}
                    subtitle="Nothing is wagered until you say so. Each challenge waits on your phone until you tap to play it."
                  />
                </Div>

                <Btn bg="#3369FF" onPress={onConfirm}>
                  <P fontFamily="DavisSans-Medium" lh={56} ta="center">{isFreePlay ? 'Got it!' : 'Confirm'}</P>
                </Btn>
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default PlayModeModal;
